export const loaderTexts = [
  'Изучаем вашу кредитную историю',
  'Ищем банки с выгодными условиями',
  'Расставляем всё по своим местам',
  'Еще чуть-чуть и будет готово',
];
